/**
 * CDR NA LINHA DA FATURA (auditoria do painel, 07/10/2026, decisão do Heitor).
 *
 * Palavras dele: "ter visual que a fatura PRECISA do CDR aplicado e marcar SE ESTÁ APLICADO OU NÃO". São dois
 * estados, e o primeiro é a condição do segundo:
 *  1. a fatura PRECISA de CDR? A assinatura dela tem "Incluir tarifas de consumo (CDR) na fatura" ligado
 *     (`contracts.includeUsageItems`);
 *  2. e o CDR FOI aplicado? A fatura tem consumo processado (`usageItems`, ou as listas de entrada).
 *
 * Fatura que não precisa: NADA. É a maioria (130 de 145 em outubro/2026), e qualquer marca nela seria ruído
 * para servir as 15 que precisam.
 *
 * ⚠️ O estado "precisa e NÃO foi aplicado" nunca aconteceu: medido pelo Maestro em 07/10/2026, ZERO nas 111
 * faturas das 16 assinaturas com CDR ligado, nos sete meses da base. Ele existe para o dia em que acontecer,
 * e por isso é AVISO; o aplicado é quieto, informação e não alarme.
 *
 * "Aplicado" é consumo PROCESSADO, não consumo cobrado: há tarifa zero (minutos com valor R$ 0,00). O sinal é
 * o consumo, e não o registro de chamada anexado (`cdrRecords`), que a lista não traz e o Heitor não pediu.
 */

export interface ItemDeConsumo {
  minutes?: number | string | null;
  totalValue?: number | string | null;
}

export interface FaturaComConsumo {
  status?: string;
  usageItems?: ItemDeConsumo[] | null;
  usageItemsEntrada?: ItemDeConsumo[] | null;
  usageItemsEntradaNormal?: ItemDeConsumo[] | null;
}

export interface EstadoDoCdr {
  aplicado: boolean;
  tom: 'quieto' | 'aviso';
  texto: string;
  titulo: string;
}

const brl = (v: number) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/** `precisa` = a assinatura da fatura tem o CDR ligado. Sem assinatura (consolidada, avulsa), não precisa. */
export function estadoDoCdr(inv: FaturaComConsumo, precisa: boolean): EstadoDoCdr | null {
  if (!precisa || inv.status === 'Cancelada') return null;
  const itens = [...(inv.usageItems || []), ...(inv.usageItemsEntrada || []), ...(inv.usageItemsEntradaNormal || [])];
  if (itens.length === 0) {
    return {
      aplicado: false,
      tom: 'aviso',
      texto: 'CDR não aplicado',
      titulo: 'A assinatura inclui as tarifas de consumo (CDR) na fatura, e esta fatura não tem consumo processado.',
    };
  }
  const minutos = itens.reduce((s, i) => s + (Number(i.minutes) || 0), 0);
  const valor = itens.reduce((s, i) => s + (Number(i.totalValue) || 0), 0);
  return {
    aplicado: true,
    tom: 'quieto',
    texto: 'CDR aplicado',
    titulo: `Consumo processado: ${itens.length} ${itens.length === 1 ? 'tarifa' : 'tarifas'}, ${Math.round(minutos)} min, R$ ${brl(valor)}.`,
  };
}
